<template>
  <BaseModal :modalTitle="$t('W: Bekræft pinkode')">
    <div v-if="!currentUser?.options.hasPinCode">
      <InfoText
        :text="
          $t(
            'W: Du har ikke oprettet en pinkode endnu. Gå til din profil for at oprette en.'
          )
        "
        theme="info" />
    </div>

    <UiBaseFormVee
      v-else
      submitOnEnter
      :errorText="errorText"
      :onSubmit="onSubmit">
      <div class="mb-4">
        <span class="mb-1 block text-sm font-medium">
          {{ $t('W: Pinkode') }}
        </span>
        <PinInput
          ref="pinInput"
          v-model="pin"
          :isError="isError"
          @update:model-value="onPinInput" />
      </div>

      <template #buttons>
        <UiBaseButton
          :text="$t('action.confirm')"
          :isLoading="isLoading"
          type="submit" />
      </template>
    </UiBaseFormVee>
  </BaseModal>
</template>

<script lang="ts">
import { managementApi } from '@/globals/typescript/utils/api/managementClient'
import { useUserStore } from '@/stores/userStore'
import { useToast } from '@/globals/typescript/utils/toast'
import { mapState } from 'pinia'
import type { PropType } from 'vue'

export default {
  name: 'EnterPinModal',
  emits: ['close'],
  props: {
    onConfirm: {
      type: Function as PropType<() => Promise<void>>,
      required: true,
    },
  },
  data() {
    return {
      pin: '',
      isLoading: false,
      errorText: '',
      isError: false,
    }
  },
  computed: {
    ...mapState(useUserStore, ['currentUser']),
  },
  methods: {
    onPinInput() {
      this.errorText = ''
      this.isError = false
    },
    async onSubmit() {
      this.errorText = ''
      this.isError = false

      if (this.pin.length < 4) {
        this.errorText = this.$t('W: Pinkoden skal være 4 cifre')
        this.isError = true
        return
      }

      this.isLoading = true
      try {
        const result = await managementApi('post', '/users/me/pin/verify', {
          body: { pin: this.pin },
        })

        if (result.success) {
          useToast().success(this.$t('W: Pinkode bekræftet'))
          try {
            await this.onConfirm()
            this.$emit('close')
          } catch {
            this.errorText = this.$t('W: Der opstod en fejl')
          }
          return
        }

        this.errorText = this.$t('W: Forkert pinkode')
        this.isError = true
        this.pin = ''
        this.$nextTick(() => {
          ;(
            this.$refs.pinInput as InstanceType<
              typeof import('@/components/PinInput.vue').default
            >
          )?.focus()
        })
      } catch {
        this.errorText = this.$t('W: Der opstod en fejl')
        useToast().error(this.errorText)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

